var map = {
	"./0x0000000000000000000000000000000000000000.svg": 751,
	"./0x1E991eA872061103560700683991A6cF88BA0028.svg": 752,
	"./0x568d925774be9967F23d7e878A6692068de569E2.svg": 753,
	"./0xb2a83eD5Ad69933067dF57FE9273f85fe32FFcFa.svg": 754,
	"./0xbbe47167666100eC33de9079c1EE7B150cCbD874.svg": 755,
	"./0xc778417E063141139Fce010982780140Aa0cD5Ab.svg": 756,
	"./0xc7AD46e0b8a400Bb3C915120d284AafbA8fc4735.svg": 757,
	"./0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56.svg": 758,
	"./avax.svg": 759,
	"./bnb.svg": 760,
	"./dai.svg": 761,
	"./eth.svg": 762,
	"./link.svg": 763,
	"./matic.svg": 764,
	"./niftsy.svg": 765,
	"./plasma.svg": 766,
	"./pos.svg": 767,
	"./techniftsy.svg": 768,
	"./usdc.svg": 769,
	"./usdt.svg": 770
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 183;